'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EntityService = function () {
  function EntityService($http, appConfig) {
    "ngInject";

    (0, _classCallCheck3.default)(this, EntityService);
    this._$http = $http;
    this._appConfig = appConfig;
  }

  (0, _createClass3.default)(EntityService, [{
    key: 'listEntitiesOld',
    value: function listEntitiesOld(entityType, entityId) {
      return this._$http.get(this._appConfig.apiServiceBaseUri + 'api/entity/list/' + entityType + '/' + entityId);
    }
  }, {
    key: 'addEntity',
    value: function addEntity(entity) {
      return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/entity/add', entity);
    }
  }, {
    key: 'addUser',
    value: function addUser(user) {
      return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/user/add', user);
    }
  }, {
    key: 'getEntity',
    value: function getEntity(entityId) {
      return this._$http.get(this._appConfig.apiServiceBaseUri + ('api/entity/get/' + entityId));
    }
  }, {
    key: 'listEntities',
    value: function listEntities(filterParams, pageStart, pageSize) {
      var query = '?pageStart=' + pageStart + '&itemsToFetch=' + pageSize;

      if (filterParams && filterParams.name) {
        query += '&name=' + filterParams.name;
      }

      if (filterParams && filterParams.entityType) {
        query += '&entityType=' + filterParams.entityType;
      }

      if (filterParams && filterParams.brandType) {
        query += '&brandType=' + filterParams.brandType;
      }

      if (filterParams && filterParams.state) {
        query += '&state=' + filterParams.state;
      }

      if (filterParams && filterParams.sortExpression) {
        query += '&sortExpression=' + filterParams.sortExpression + '&ascending=' + filterParams.ascending;
      }

      return this._$http.get(this._appConfig.apiServiceBaseUri + 'api/entity/list' + query);
    }
  }, {
    key: 'updateEntityState',
    value: function updateEntityState(entityId, state) {
      return this._$http.get(this._appConfig.apiServiceBaseUri + ('api/entity/update/' + entityId + '/' + state));
    }
  }, {
    key: 'updateUserPreferences',
    value: function updateUserPreferences(userPreferences) {
      return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/entity/updateuserpref/', userPreferences);
    }
  }, {
    key: 'listAllLocations',
    value: function listAllLocations() {
      return this._$http.get(this._appConfig.apiServiceBaseUri + 'api/entity/listalllocations');
    }
  }, {
    key: 'listAllImportLocations',
    value: function listAllImportLocations() {
      return this._$http.get(this._appConfig.apiServiceBaseUri + 'api/entity/listallimportlocations');
    }
  }, {
    key: 'getEntityPreferences',
    value: function getEntityPreferences(entityId) {
      return this._$http.get(this._appConfig.apiServiceBaseUri + ('api/entity/getentitypreferences/' + entityId));
    }
  }, {
    key: 'updateEntityPreferences',
    value: function updateEntityPreferences(entityPrefs) {
      return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/entity/updateentitypreferences', entityPrefs);
    }
  }, {
    key: 'getEntityReportsAccess',
    value: function getEntityReportsAccess(entityId) {
      return this._$http.get(this._appConfig.apiServiceBaseUri + ('api/entity/getentityreportsaccess/' + entityId));
    }
  }, {
    key: 'toggleEntityReportAccess',
    value: function toggleEntityReportAccess(entityId, reportId) {
      return this._$http.get(this._appConfig.apiServiceBaseUri + ('api/entity/toggleentityreportaccess/' + entityId + '/' + reportId));
    }
  }, {
    key: 'updateStockProvider',
    value: function updateStockProvider(stockProviderViewModel) {
      return this._$http.post(this._appConfig.apiServiceBaseUri + 'api/entity/updatestockprovider/', stockProviderViewModel);
    }
  }]);
  return EntityService;
}();

exports.default = EntityService;


// WEBPACK FOOTER //
// ./client/app/components/admin/entity/entity.service.js